import { BarChart3, FilterX } from 'lucide-react';
import { EmptyState } from '@/components/shared/EmptyState';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';

type ChartEmptyStateProps = {
  variant: 'no-match' | 'no-data';
  onResetFilters?: () => void;
  onEditConfig?: () => void;
};

/** Empty chart area: no trace matched the filters (`no-match`) or no data at all (`no-data`). */
export function ChartEmptyState({ variant, onResetFilters, onEditConfig }: ChartEmptyStateProps) {
  const { t } = useTranslation();

  const actions = (
    <>
      {variant === 'no-match' && onResetFilters && (
        <Button variant="outline" size="sm" onClick={onResetFilters}>
          {t('analytics.dashboard.complexCharts.emptyState.resetFilters')}
        </Button>
      )}
      {variant === 'no-match' && onEditConfig && (
        <Button variant="outline" size="sm" onClick={onEditConfig}>
          {t('analytics.dashboard.complexCharts.emptyState.editConfig')}
        </Button>
      )}
      {variant === 'no-data' && onEditConfig && (
        <Button variant="outline" size="sm" onClick={onEditConfig}>
          {t('analytics.dashboard.complexCharts.emptyState.configure')}
        </Button>
      )}
    </>
  );
  const hasAction = Boolean(onEditConfig || (variant === 'no-match' && onResetFilters));

  return (
    <EmptyState
      size="compact"
      icon={variant === 'no-match' ? FilterX : BarChart3}
      title={
        variant === 'no-match'
          ? t('analytics.dashboard.complexCharts.emptyState.filterTitle')
          : t('analytics.dashboard.complexCharts.emptyState.noDataTitle')
      }
      description={
        variant === 'no-match'
          ? t('analytics.dashboard.complexCharts.emptyState.filterBody')
          : t('analytics.dashboard.complexCharts.emptyState.noDataBody')
      }
      action={hasAction ? actions : undefined}
      className="min-h-[200px] w-full"
    />
  );
}
